import { useState } from 'react';
import { Collapse } from 'react-collapse';
import { useDispatch, useSelector } from 'react-redux';
import { togglePlaying } from 'Actions';
import { StoryAccordionTitle } from 'Elements';
import styles from 'partials/story-box.module.scss';

export const SidebarStoryAccordion = ({
	children,
	title,
	icon,
	isOpenbox = false
}) => {
	const [isOpen, setOpen] = useState(isOpenbox);
	const track = useSelector((state) => state.player);
	const dispatch = useDispatch();

	const handleOpen = () => {
		setOpen(!isOpen);
		!!isOpen && track.isPlaying && dispatch(togglePlaying(false));
	};

	return (
		<div className={styles.box}>
			<StoryAccordionTitle
				hasExpand
				isOpen={isOpen}
				title={title}
				icon={icon}
				onOpen={handleOpen}
			/>
			<Collapse isOpened={isOpen} className={styles.collapse}>
				<div className={styles.content}>{children}</div>
			</Collapse>
		</div>
	);
};
